import { Rail } from "types";

export default {
  type: "rail",
  uuid: "ded2f577-d003-45a7-9f2c-bf0e79e613d6",
  template: "tile-square",
  title: "Apps",
  tiles: [
    {
      type: "titleTile",
      title: "Apps",
      actionText: "View all",
      hero: {
        mode: "standard",
        title: "Apps",
        synopsis: "Explore your apps, all from one place.",
        heroImageUrl: "assets/images/apps/bbc-bg.jpg",
      },
    },
    {
      type: "squareTile",
      imageUrl: "assets/images/apps/iplayer.png",
      hero: {
        mode: "standard",
        title: "iPlayer",
        synopsis:
          "BBC iPlayer is an internet streaming, catchup, television and former radio service from the BBC.",
        heroImageUrl: "assets/images/apps/bbc-bg.jpg",
      },
    },
    {
      type: "squareTile",
      imageUrl: "assets/images/apps/netflix.png",
      hero: {
        mode: "standard",
        title: "Netflix",
        synopsis:
          "Watch Netflix movies & TV shows online or stream right to your smart TV, game console, PC, Mac, mobile, tablet and more.",
        heroImageUrl: "assets/images/apps/netflix-bg.jpg",
      },
    },
    {
      type: "squareTile",
      imageUrl: "assets/images/apps/disney.png",
      hero: {
        mode: "standard",
        title: "Disney",
        synopsis:
          "From classics to new releases, stream stories that you won't find anywhere else.",
        heroImageUrl: "assets/images/apps/disney-bg.jpg",
      },
    },
    {
      type: "titleTile",
      actionText: "View all",
      hero: {
        mode: "standard",
        heroImageUrl: "assets/images/apps/disney-bg.jpg",
      },
    },
  ],
} as Rail;
